export enum MfaType {
  Google = 1,
  Email = 2,
}